import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrok = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9544_207)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.34176 0H12.5999C14.4701 0 16.0002 1.63334 16.0002 3.6296V12.3704C16.0002 14.3667 14.4701 16 12.5999 16H4.34176C2.47158 16 0.941406 14.3667 0.941406 12.3704V3.6296C0.941406 1.63334 2.47158 0 4.34176 0Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.09258 9.27087L12.3566 3.61978V3.62508L13.877 2C13.8498 2.04144 13.8223 2.08178 13.7951 2.12213C12.6398 3.82259 12.0757 4.65407 12.5283 6.73469L12.5257 6.73152C12.8378 8.14773 12.5038 9.71831 11.4258 10.8705C10.0665 12.3242 7.89144 12.6477 6.10038 11.3391L7.34926 10.7214C8.49229 11.2011 9.74314 10.9905 10.6418 10.0298C11.5408 9.06913 11.7428 7.67022 11.2908 6.5057C11.2049 6.28515 10.9476 6.22958 10.7675 6.37186L7.09258 9.27087ZM6.33417 9.97528L6.3332 9.97634L2.82373 13.327C3.04623 12.9996 3.32247 12.6899 3.59805 12.3805C4.37535 11.5076 5.14667 10.6425 4.67611 9.4199C4.04605 7.78387 4.41282 5.86675 5.57976 4.61973C6.79279 3.32457 8.57917 2.99785 10.0711 3.65409C10.4014 3.78507 10.6892 3.97162 10.9134 4.14507L9.66755 4.7599C8.50755 4.23991 7.17847 4.59354 6.36735 5.46041C5.27035 6.63168 5.04852 8.66276 6.33417 9.97528Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9544_207",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgGrok;
